module.exports = __webpack_public_path__ + "static/media/aws.6bb0fcd0.png";